
import React from 'react';
import { Overlay } from "./modal";

class SpinnerOverlay extends React.Component {
  
  render = () => {

    return (
      <Overlay show={true}>
        <div align={"center"}>
          <i
            color={"#FFF"}
            className={"fa fa-spinner fa-spin fa-5x fa-fw"}/>
        </div>
      </Overlay>
    );
  }
}

export { SpinnerOverlay };
